import { useQuery } from "@tanstack/react-query";
import { apiCall } from "../lib/apiClient";

/** Registr držitelů (PO legal / FO physical) — spec-proposal 2026-05-30-02. */
export interface HolderRow {
  id: string;
  tenant_id: string;
  holder_type: "legal" | "physical";
  display_name: string;
  user_id: string | null;
  ico: string | null;
  dic: string | null;
  address: string | null;
  deactivated_at: string | null;
}

export interface HolderListResponse {
  rows: HolderRow[];
}

/** Seznam držitelů (volitelně filtr na tenant) pro výběr při přiřazení karty. */
export function useHoldersList(
  tenantId?: string,
  options?: { enabled?: boolean },
) {
  return useQuery({
    queryKey: ["admin", "holders", "list", tenantId ?? "all"] as const,
    queryFn: () =>
      apiCall<HolderListResponse>(
        tenantId
          ? `/api/admin/holders?tenant_id=${encodeURIComponent(tenantId)}`
          : "/api/admin/holders",
      ),
    enabled: options?.enabled ?? true,
    staleTime: 30_000,
  });
}
